// extracted by mini-css-extract-plugin
export default {"card":"task_card__3++zy"};